import { PlusIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

// Small "+" that starts the inline task add; shared by the compact section label
// and the comfortable section header.
export const DashboardTaskAddButton = ({
  onClick,
}: {
  onClick: () => void;
}) => (
  <Button
    className="h-5 w-5 shrink-0 p-0 text-slate-400 hover:bg-slate-100 hover:text-slate-600"
    onClick={onClick}
    size="icon"
    type="button"
    variant="ghost"
  >
    <PlusIcon className="h-3.5 w-3.5" />
  </Button>
);
